import React, { Component } from 'react'
import getText from '../strings'
import styled from 'react-emotion'
import { Message } from '../../styles'

const Wrapper = styled('div')`
  .btn {
    margin-top: 10px;
  }
`

const forgetme = 'forgetme'

export default class WizardStep4 extends Component {
  componentDidMount() {
    if (this.props.caseType === forgetme)
      window.addEventListener('beforeunload', this.props.signOut)
  }
  componentWillUnmount() {
    if (this.props.caseType === forgetme)
      window.removeEventListener('beforeunload', this.props.signOut)
    else
      window.location.reload()
  }
  render() {
    const { caseType, email, error } = this.props
    const text = caseType === forgetme ? getText('wizard', 'step4', 'caseDeleteInformation') : getText('wizard', 'step4', 'caseOrderInformation')
    return (
      <Wrapper>
        {!error && <h2>{getText('wizard', 'step4', 'orderSubmitted')}</h2>}
        {!error && <p>{text.replace('{0}', email)}</p>}
        {error && <Message error={true}>{getText('errors', 'general')}</Message>}
      </Wrapper>
    )
  }
}
